<template>
  <main class="view support">
    <div class="descriptor">
      <h1>{{ $t('support.headline') }}</h1>
      <p>{{ $t('support.copy') }}</p>
    </div>
    <div class="container">
      <Accordion :items="$t('support.items')" />
    </div>
  </main>
</template>

<script>
  import Accordion from '@/components/ui/Accordion';

  export default {
    name: 'Support',
    components: {
      Accordion,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.support {
  & > h1 {
    text-align: center;
    margin-bottom: 48px;
  }
  & > .container {
    position: relative;
    background-color: $color-white-solid-10;
    border-radius: $default-border-radius;
    min-height: 150px;
    width: 100%;
    filter: $box-shadow-2;
    margin: 0 auto 0 auto;
    padding: 32px;
    outline: 0;

    a {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 5px;
      color: $color-blue-solid-100;
    }
  }
}
</style>
